<template>
    <div class="uniform-choice" :class="{'disabled': disabled}">
        <span :class="{'checked': modelValue}">
            <input type="radio" class="form-check-input-styled" :disabled="disabled" :checked="modelValue" @change="$emit('update:modelValue', !modelValue)">
        </span>
    </div>
</template>
<script>
export default {
    name: "Radio",
    props: {
        modelValue: {
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>